
import { BASE_URL } from "../config/config";
import axios from "axios";

export const fetchAllProducts = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/course`);
    return response.data.data;
	
  } catch (error) {
    throw error;
  }
};

export const fetchCourseByName = async (courseName) => {
  try {
    const response = await axios.post(`${BASE_URL}/getCourseByName`, {
      name: courseName
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
// fetch categories
export const fetchCategories = async () => {
  try {
    const response = await axios.post(`${BASE_URL}/categories`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};